import React from 'react';
import { Routes, Route } from 'react-router-dom';

import Home from './pages/Home/Home';
import About from './pages/About';
import Portfolio from './pages/Portfolio';
import LandingPage from './pages/Sale/LandingPage';
import Terms from './pages/Terms/Terms';
import CalendlyPixelBridge from './components/Analytics/CalendlyPixelBridge';

function App() {
  return (
    <>
      <CalendlyPixelBridge />

      <Routes>
        <Route path="/" element={<Home />} />
        {/* <Route path="/about" element={<About />} /> */}
        {/* <Route path="/portfolio" element={<Portfolio />} /> */}
        <Route path="/insta" element={<LandingPage />} />
        <Route path="/terms" element={<Terms />} />
      </Routes>
    </>
  );
}

export default App;
